module.exports = __webpack_public_path__ + "static/media/Piercing-mascintimate-frenum.c5ef106b.png";